<template>
  <layout>
    <div slot="banner"></div>
    <div class="rule">
      <!-- 报名规则 -->
      <RegistrationRules :data="info.applyRule" />

      <!-- 参赛流程 -->
      <Process :data="info.process" />

      <!-- 评审规则 -->
      <ReviewRule :data="info.reviewRule" />

      <!-- 十家实习单位 -->
      <!-- <PracticeUnit :data="info.unit" /> -->

      <!-- 参赛注意事项 -->
      <CompetitionStatement :data="info.notice" />
    </div>
  </layout>
</template>

<script>
import layout from '@/components/layout/layout'

import RegistrationRules from './RegistrationRules.vue'
import Process from './Process.vue'
import ReviewRule from './ReviewRule.vue'
// import PracticeUnit from './PracticeUnit.vue'
import CompetitionStatement from './CompetitionStatement'

export default {
  name: 'Home',
  components: {
    layout,
    RegistrationRules,
    Process,
    ReviewRule,
    CompetitionStatement
    // PracticeUnit
  },
  created () {
  },
  computed: {
    info () {
      return this.$t('rule')
    }
  }
}
</script>
<style lang="scss" scoped>
.rule {
  padding-top: 66px;

  @include mobile {
    padding-top: 0;
  }
}
</style>
